import React from "react";
import { AllergyCard, MedicalHistoryCard, ProviderNotesCard, UpcomingAppointmentsCard, VaccinationCard} from "components";
import {Medications,  AddVitals} from "pageComponents";
import { WidgetDashboardManager } from "pageComponents";

const widgetComponentMap = {
  'app-appointments': UpcomingAppointmentsCard,
  'app-allergies': AllergyCard,
  'app-medications': Medications,
  'app-vitals': AddVitals,
  'app-medical-history': MedicalHistoryCard,
  'app-provider-notes': ProviderNotesCard,
  'app-vaccination-immunization-record': VaccinationCard
};

const WidgetsDashboard = (props) => {
  return (
    <WidgetDashboardManager widgetComponentMap={widgetComponentMap} userId={props.userId} selectedFamilyMember={props.selectedFamilyMember} />
  );
};

export default WidgetsDashboard;